import reducer from './reducers';
import * as studyTasksActions from './actions';
import * as studyTasksSelectors from './selectors';

export { studyTasksActions, studyTasksSelectors };
export default reducer;
